module.exports = __webpack_public_path__ + "img/logoHCM.81f3c2ce.jpg";